export const DataLineageKey = {
    GROUP: 'group',
    INPUT_DATA: 'inputData',
    SI_DATA: 'siData',
    EF_DATA: 'eFData',
    EMISSION_FACTOR: 'emissionFactor',
    EF_UNIT: 'efUnit',
    URL: 'url',
    URL_NAME: 'urlName',
    EMISSIONS_FACTOR_SOURCE: 'emissionsFactorSource',
    YEARLY_EMISSIONS: 'yearlyEmissions'
  };
  export const DataLineageLabel = {
    GROUP: 'Group',
    INPUT_DATA: 'Input data',
    SI_DATA: 'Converted',
    EF_DATA: 'Emission Factor',
    EMISSION_FACTOR: 'Emission Factor',
    EF_UNIT: 'Emission Factor Unit',
    URL: 'Emission Factor URL',
    URL_NAME: 'Emissions Factor Source',
    YEARLY_EMISSIONS: 'Total Emissions'
  };